<template>
  <section class="pt-16 bg-gradient-to-br from-primary-50 via-white to-purple-50 min-h-screen flex items-center">
    <div class="container-custom">
      <div class="grid lg:grid-cols-2 gap-10 items-center">
        <!-- Left Content -->
        <div class="space-y-6">
          <!-- Badge -->
          <div class="inline-flex items-center mt-2 px-4 py-2 rounded-full bg-primary-100 text-primary-800 text-sm font-medium">
            <i class="fas fa-star mr-2"></i>
            #1 WordPress Project Management Plugin
          </div>
          
          <!-- Latest Updates Badge -->
          <div class="inline-flex items-center px-4 py-2 rounded-full bg-green-100 text-green-800 text-sm font-medium animate-pulse">
            <i class="fas fa-sparkles mr-2"></i>
            Latest Update: 80% Performance Boost + Public Visibility
          </div>
          
          <!-- Main Headline -->
          <h1 class="text-4xl font-bold text-gray-900 leading-tight">
            Transform Your WordPress Into a
            <span class="gradient-text">Professional Project Management</span>
            Platform
          </h1>
          
          <!-- Subheadline -->
          <p class="text-lg text-gray-600 leading-relaxed">
            <strong>Finally, a project management solution that doesn't break the bank!</strong> Task Manager Pro 
            replaces expensive tools like Asana, Monday.com, and Trello with a powerful WordPress plugin that 
            provides superior functionality tailored to your business needs. <strong>Now with industry-leading performance 
            and public visibility features!</strong>
          </p>
          
          <!-- Key Benefits -->
          <div class="grid md:grid-cols-2 gap-4 py-6">
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <i class="fas fa-rocket text-green-600 text-sm"></i>
              </div>
              <div>
                <div class="font-semibold text-gray-900">3x Faster Setup</div>
                <div class="text-sm text-gray-600">Install and start in 5 minutes</div>
              </div>
            </div>
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <i class="fas fa-shield-alt text-blue-600 text-sm"></i>
              </div>
              <div>
                <div class="font-semibold text-gray-900">Your Data Stays Private</div>
                <div class="text-sm text-gray-600">No third-party cloud storage</div>
              </div>
            </div>
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                <i class="fas fa-cogs text-purple-600 text-sm"></i>
              </div>
              <div>
                <div class="font-semibold text-gray-900">Fully Customizable</div>
                <div class="text-sm text-gray-600">Match your brand perfectly</div>
              </div>
            </div>
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                <i class="fas fa-users text-orange-600 text-sm"></i>
              </div>
              <div>
                <div class="font-semibold text-gray-900">Team Collaboration</div>
                <div class="text-sm text-gray-600">Real-time collaboration features</div>
              </div>
            </div>
          </div>
          
          <!-- CTA Buttons -->
          <div class="flex flex-col sm:flex-row gap-4">
            <a href="https://tmp.softentra.com/wp-admin/admin.php?page=task-manager-pro" target="_blank" class="btn-primary text-lg px-8 py-4 group">
              <i class="fas fa-rocket mr-2 group-hover:animate-bounce"></i>
              Live Demo
            </a>
            <a href="https://www.softentra.com/products/task-manager-pro-wordpress-project-management-plugin-with-time-tracking-team-collaboration" target="_blank" class="btn-outline text-lg px-8 py-4 group">
              <i class="fas fa-shopping-cart mr-2 group-hover:scale-110 transition-transform"></i>
              Buy Now
            </a>
          </div>
          
          <!-- Trust Indicators -->
          <div class="flex items-center space-x-8 pt-8 border-t border-gray-200">
            <div class="text-center">
              <div class="text-2xl font-bold text-gray-900">4.9★</div>
              <div class="text-sm text-gray-600">Average Rating</div>
            </div>
            <div class="text-center">
              <div class="text-2xl font-bold text-gray-900">Lifetime</div>
              <div class="text-sm text-gray-600">Free Updates</div>
            </div>
            <div class="text-center">
              <div class="text-2xl font-bold text-gray-900">24/7</div>
              <div class="text-sm text-gray-600">Expert Support</div>
            </div>
          </div>
          

        </div>
        
        <!-- Right Content - Hero Image -->
        <div class="relative">
          <!-- Main Dashboard Mockup -->
          <div class="relative">
            <div class=" rounded-lg mb-4 p-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="font-semibold text-gray-900">User Dashboard</h3>
                <div class="flex space-x-2">
                  <div class="w-3 h-3 bg-red-400 rounded-full"></div>
                  <div class="w-3 h-3 bg-yellow-400 rounded-full"></div>
                  <div class="w-3 h-3 bg-green-400 rounded-full"></div>
                </div>
              </div>
              <!-- Enhanced Dashboard Preview -->
              <div class="bg-gradient-to-r from-primary-100 to-purple-100 rounded-lg h-64 flex items-center justify-center relative overflow-hidden">
                <img src="/project-dashboard.jpg" alt="project dashboard" />
                <!-- Floating Elements -->
              </div>
            </div>
          </div>
          
          <!-- Floating Elements -->
          <div class="absolute -top-4 -right-4 bg-white rounded-xl shadow-lg p-4 transform hover:rotate-0 transition-transform duration-300">
            <div class="flex items-center space-x-2">
              <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <i class="fas fa-check text-green-600"></i>
              </div>
              <div>
                <div class="text-sm font-medium text-gray-900">Task Completed</div>
                <div class="text-xs text-gray-500">+25% productivity</div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    
    <!-- Background Elements -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute top-20 left-10 w-72 h-72 bg-primary-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
      <div class="absolute top-40 right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
      <div class="absolute bottom-20 left-1/2 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>
